/* eslint-disable react-hooks/exhaustive-deps */
import { Footer } from '@orientaction/components';
import { getFromLS } from '@orientaction/utils';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import AppHeader from '../../pages/Redesign/shared/header';
import style from './JobLayoutStyle';

const JobLayout = ({
  children,
  isaddBackground,
  noPadding,
  classname,
  isNew,
  isNew2,
  showLink = true,
  footer,
  isNew3,
  isClassic,
  showOverFlow = false,
  useHeader = true,
  hasMinHeight = false,
}: any) => {
  const history = useHistory();
  const cls = style();
  const user = JSON.parse(getFromLS('userInfos') || '{}');

  if (!user?.id) {
    history.push('/');
  }

  return (
    <div className={clsx(cls.layout, classname)}>
      <div
        className={clsx(
          cls.content,
          isaddBackground ? cls.grayBG : null,
          noPadding ? cls.noPadding : null,
          isNew ? cls.imageBG : null,
          isNew2 ? cls.imageBG2 : null,
          isNew3 ? cls.imageBG3 : null,
          isClassic ? cls.imageClassic : null,
        )}>
        {useHeader && (
          <AppHeader showNav={showLink} isJobLayout={true} isUserConnected={!!user?.id} />
        )}

        <div
          className={cls.children}
          style={{
            overflow: showOverFlow ? 'visible' : 'none',
            minHeight: hasMinHeight ? '100vh' : '',
          }}>
          {children}
          {footer && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default JobLayout;
